import React from 'react';
import BankErrorComponent from './bank-error-list.component';

const BankErrorList = (props) => {
    return <BankErrorComponent {...props} />;
};

export default BankErrorList;
